import type {
  ForgotPasswordRequest,
  ForgotPasswordResponse,
} from "../types/auth.type";
import type { IAuthRepository } from "../repositories/AuthRepository";
import { getErrorMessage } from "../utils/errorMessage";
export interface IForgotPasswordUseCase {
  execute(request: ForgotPasswordRequest): Promise<ForgotPasswordResponse>;
}
export class ForgotPasswordUseCase implements IForgotPasswordUseCase {
  constructor(private readonly authRepository: IAuthRepository) {}
  async execute(
    request: ForgotPasswordRequest,
  ): Promise<ForgotPasswordResponse> {
    // Validate input
    if (!request.email) {
      throw new Error("Email is required");
    }
    if (!this.isValidEmail(request.email)) {
      throw new Error("Invalid email format");
    }
    try {
      // Call repository to send password reset email
      const response = await this.authRepository.forgotPassword(request);
      return response;
    } catch (error: unknown) {
      throw new Error(
        getErrorMessage(
          error,
          "Failed to send password reset instructions. For security, instructions are only sent if the email is registered.",
        ),
      );
    }
  }
  private isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}
// Factory function to create use case with dependencies
export const createForgotPasswordUseCase = (
  authRepository: IAuthRepository,
): ForgotPasswordUseCase => {
  return new ForgotPasswordUseCase(authRepository);
};
